// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import IconEducator from '@/components/icons/educator.vue'
import IconCheck from '@/components/icons/check.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import Axios from "axios"

export default {
    name: 'ServiceWelcome',
    components: {
        IconEducator,
        IconCheck,
        IconBase,
        IconForwardBack
    },
    data () {		          
        return {
            dialog_check_sessions: false,		        
            confirm_birth_day: "",		
            confirm_birth_month: "",		
            confirm_birth_year: "",		
            db_birthdate: "",		
            db_session: "",		
            wrong_birthday: "",		
            days_of_the_month: [],		
            month_of_the_year: [		
                { text:'January', value:'1' },		
                { text:'February', value:'2' },		
                { text:'March', value:'3' },		
                { text:'April', value:'4' },		
                { text:'May', value:'5' },		
                { text:'June', value:'6' },		
                { text:'July', value:'7' },		
                { text:'August', value:'8' },		
                { text:'September', value:'9' },		
                { text:'October', value:'10' },		
                { text:'November', value:'11' },		
                { text:'December', value:'12' }		
            ],		
            years: [],		
            dictionary: {		
                custom: {		
                    confirm_birth_day: {		
                        required: () => 'Birth day is required to proceed'		
                    },		
                    confirm_birth_month: {		
                        required: () => 'Birth month is required to proceed'		
                    },		
                    confirm_birth_year: {		
                        required: () => 'Birth year is required to proceed'		
                    }		
                }		
            },		
        }    		
    },
    mounted() {
        this.$parent.CheckWindowPathName();
    },
    methods: {
        Next() {
            this.$router.push({ name: 'AlreadyAMember' });
        },
        disableModal(){		
            this.dialog_check_sessions = false;		
        },		
        Continue(_params){		
            if(_params == "No"){		
                this.NotContinue();		
            }else{		
                this.YesContinue();		
            }		
        },		
        NotContinue() {		
            this.disableModal();		
            this.$parent.UpdateIsDeletedToTrue(this.current_session_id, "ServiceInsuranceProcess");		
            this.$parent.CleanStorage("ServiceInsuranceProcess");		
        },		
        YesContinue(){		
            var confirm_bdate = new Date(this.confirm_birth_year,this.confirm_birth_month.value,this.confirm_birth_day);		
            var dbbirthdate = new Date(this.db_birthdate);		
            var confirm_bdate_ = confirm_bdate.getFullYear() + '-' + confirm_bdate.getMonth() + '-' + confirm_bdate.getDate();		
            var dbbirthdate_ = dbbirthdate.getFullYear() + '-' + (dbbirthdate.getMonth() + 1) + '-' + dbbirthdate.getDate();		
            if(dbbirthdate_ == confirm_bdate_) {		
                //if the same repopulate		
                this.$parent.ServiceInsuranceProcess = JSON.parse(this.db_session.data);		
                this.$parent.is_local_storage = true;		
                this.$parent.session_id = this.db_session.id;		
                this.$parent.SessionUpdate("ServiceInsuranceProcess");		
	
                this.disableModal();		
            }else{		
                this.wrong_birthday = "Birthday does not match! Please try again."		
                this.dialog_check_sessions = true;		
            }  		
        },		
        CreateNumberRange(_start, _end) {		
            let _data = [];		
            for(var i = _start; i <= _end; i++) {		
                if(i < 10) { _data.push("0" + i); } else { _data.push(i); }		
            }		
            return _data;		
        }
    },
    mounted() {
        this.$parent.CheckWindowPathName();
        this.$parent.CurrentProcess = "ServiceInsuranceProcess";
        this.$validator.localize('en', this.dictionary); 		
        this.years = this.CreateNumberRange((new Date()).getFullYear() - 100,(new Date()).getFullYear());		
        this.days_of_the_month = this.CreateNumberRange(1,31);		
        let check = localStorage.getItem("ServiceInsuranceProcess");		
        //axios		
        let CheckSessionByEmail_ = this.$parent.CheckSessionByEmail("ServiceInsuranceProcess");		
        //check response of axios 		
        CheckSessionByEmail_.then(response => {		
            var count = response.data.customizations.results.length;		
            this.db_session = response.data.customizations.results[0];		
            		
            //if session exist		
            if(count > 0 ){		
                //check session if not expired		
                let isSessionNotExpired = this.$parent.CheckSessionExpiry("ServiceInsuranceProcess");		
            		
                if(isSessionNotExpired == "false"){		
                    this.dialog_check_sessions = true;		
                    this.db_birthdate = this.$parent.db_session.birthdate;		
                }	
            }		
        })		
        .catch(response => {
            console.error("Check Session By Email", response);
        });
    },
    watch : {		  
        dialog_check_sessions: function (newVal, oldVal) {		       
            const handler = e => {		           
                if (e.keyCode === 27) {		     
                    this.dialog_check_sessions = false		
                    window.removeEventListener('keydown', handler)		
                }		
            }		
            if(this.dialog_check_sessions == false){		
            }else{		
                window.addEventListener('keydown', handler);		
            }		
        },		
    },
}